import script from "./NewsCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsCarousel.vue?vue&type=script&setup=true&lang=js"

import "./NewsCarousel.vue?vue&type=style&index=0&id=852cc3d0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-852cc3d0"]])

export default __exports__